import React, { memo } from 'react';
import { createUseStyles } from 'hoi-poi-ui';
import Frame from "../Frame";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'CenteredLayout');
const CenteredLayout = _ref => {
  let {
    iframeURL,
    lang,
    children
  } = _ref;
  const classes = useStyles();
  const url = `${iframeURL}?lang=${lang.toUpperCase()}` || 'https://try.forcemanager.net/app-login/';
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, iframeURL && /*#__PURE__*/React.createElement("div", {
    className: classes.frame
  }, /*#__PURE__*/React.createElement(Frame, {
    url: url
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.children
  }, children));
};
export default /*#__PURE__*/memo(CenteredLayout);